import httpRequest from "../ajax";
import cogoToast from "cogo-toast";

// services/bulkCandidateService.js

export const bulkMoveCandidates = async (jobId, candidateIds, newStage, reason = null) => {
  try {
    const response = await httpRequest(
      "post",
      "/recruiter/insight/bulk-move-candidates",
      {
        job_id: jobId,
        candidate_ids: candidateIds,
        new_stage: newStage,
        reason: reason,
      }
    );

    console.log("Bulk move response:", response.data);

    // CHANGE THIS LINE: Check for status === true OR error === false
    if (response.data.status === true || response.data.error === false) {
      return response.data;
    } else {
      cogoToast.error(response.data.message || "Failed to move candidates", {
        hideAfter: 3,
        position: "top-center",
      });
      return null;
    }
  } catch (error) {
    console.error("Error moving candidates:", error);
    cogoToast.error(
      error.response?.data?.message || "An error occurred while moving candidates",
      { hideAfter: 3, position: "top-center" }
    );
    return null;
  }
};

export const getAvailableStages = async () => {
  try {
    const response = await httpRequest(
      "get",
      "/recruiter/insight/available-stages"
    );

    if (response.data.error === false) {
      return response.data.data;
    } else {
      console.error("Failed to fetch stages:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("Error fetching stages:", error);
    return [];
  }
};
